import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { Subject } from 'rxjs';

@Component({
    selector: 'clever-preisalarmmodal',
    templateUrl: './preisalarmmodal.component.html',
    styleUrls: ['./preisalarmmodal.component.scss'],
    standalone: false
})
export class PreisalarmmodalComponent implements OnInit {
    protected unsubscribe$ = new Subject();
    showCustomPrs: boolean = false;
    error: boolean = false;
    errorpr: boolean = false;
    myEmail: string = '';
    minprc: number;
    maxprc: number;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PreisalarmmodalComponent>
    ) { }

    ngOnInit(): void {
        // console.log(this.data);
    }

    onClose(): void {
        this.dialogRef.close({});
    }

    activePrc() {
        this.error = false;
        this.errorpr = false;
        const tmp_min = !isNaN(Number(this.minprc)) ? Number(this.minprc) : 0;
        const tmp_max = !isNaN(Number(this.maxprc)) ? Number(this.maxprc) : 0;
        if (tmp_min <= tmp_max) {
            if (this.myEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                const target = {
                    email: this.myEmail,
                    minprc: !isNaN(Number(this.minprc)) ? Number(this.minprc) : 0,
                    maxprc: !isNaN(Number(this.maxprc)) ? Number(this.maxprc) : 0,
                    image: this.data.image,
                    name: this.data.hotel?.name,
                    // giataid: this.data.filter?.giataIdList,
                    type: this.data.type,
                    filter: this.data.filter,
                    productid: this.data.productid,
                    sendemailanyprcchange: !this.showCustomPrs,
                    categoryAr: this.data.categoryAr.reduce((pv, cv) => pv + cv, 0),
                    // location: this.data.hotel?.location,
                    startdate: moment().format('YYYY-MM-DD HH:mm:ss'),
                    expiredate: moment(this.data?.filter?.reisezeitraumResult?.end).subtract(7, 'days').format('YYYY-MM-DD') < moment().add(7, 'days').format('YYYY-MM-DD') ? moment(this.data?.filter?.reisezeitraumResult?.start).format('YYYY-MM-DD') : moment().add(7, 'days').format('YYYY-MM-DD'),
                    startprc: !isNaN(Number(this.data.startprc)) ? Number(this.data.startprc) : 0,
                    evolution: [{
                        prc: !isNaN(Number(this.data.startprc)) ? Number(this.data.startprc) : 0,
                        date: moment().format('YYYY-MM-DD HH:mm:ss')
                    }]
                }
                this.dialogRef.close(target);
            } else {
                this.error = true;
            }
        } else {
            this.errorpr = true;
        }
    }
}
